/**
 * The StealthOS Android app (the Solana Seeker build) opens this site in a
 * WebView and registers its `stealthNative` wallet bridge before any page
 * script runs, so the bridge's presence identifies the app. Browsers never
 * define it.
 */
export function isSeekerAndroidApp(): boolean {
  return typeof window !== "undefined" && "stealthNative" in window;
}
